import * as React from 'react'
import { InjectedFormProps, reduxForm, Field } from 'redux-form'
import { useSelector, useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import { translate } from '../../i18n'
import { IAppState } from '../../store/state.interface.web'
import { FormField } from '../../../Web/components/FormField/FormField'
import { showErrorMessage } from '../../utils'
import {setNewPassword} from './forgotPassword.reducer'
import { required } from '../../../Web/common/validate'
import LogoHeader from '../logoHeader'

interface ILayoutProps {
  token?: string
}

interface IComponentProps extends RouteComponentProps<ILayoutProps> {
}

const SetNewPasswordForm: React.FC<
  InjectedFormProps<{}, IComponentProps> & IComponentProps
> = props => {
  // * varaiable declarations
  const { handleSubmit } = props
  const loading = useSelector<IAppState, boolean>((state: IAppState) => state.forgotPassword.loading)
  const dispatch = useDispatch()

  const setNewPasswordSubmit = (submittedValues: any) => {
    if (submittedValues.password !== submittedValues.confirmPassword) {
      return showErrorMessage(
        `Password doesn't match! Enter your Password Again`
      )
    }
    const submitValues = Object.assign(submittedValues, {token: props.match.params.token!})
    dispatch(setNewPassword(submitValues))
  }

  const renderLoader = () => {
    if (loading) {
      return <em className="fas fa-circle-notch fa-spin ml-1" />
    }
  }

  return (
    <>
      <div className="block-center wd-xxxl d-flex flex-column full-height justify-content-center">
        <div className="card card-flat">
         <LogoHeader/>
          <div className="card-body">
            <p className="text-center py-2 auth-title">
              {translate('forgotPassword.setNewPassword.title')}
            </p>
            <form className="w-75 m-auto" onSubmit={handleSubmit(setNewPasswordSubmit)}>
              <p className="text-center">
                {translate('forgotPassword.setNewPassword.subtitle')}
              </p>
              <Field
                name="password"
                component={FormField}
                required
                type="password"
                placeholder={translate(
                  'forgotPassword.setNewPassword.passwordPlaceholder'
                )}
                validate={[required]}
                icon="fa-lock"
                label=""
              />{' '}
              <Field
                name="confirmPassword"
                component={FormField}
                type="password"
                placeholder={translate(
                  'forgotPassword.setNewPassword.confirmPasswordPlaceholder'
                )}
                validate={[required]}
                required
                icon="fa-lock"
                label=""
              />
              <button
                className="btn btn-primary btn-block"
                type="submit"
              >
                {translate('forgotPassword.setNewPassword.resetButtonLabel')} {renderLoader()}
              </button>
            </form>
          </div>
        </div>
        <div className="p-3 text-center">
          <span className="mr-2">&copy;</span>
          <span>{translate('authLayout.copyRights')}</span>
          <span className="mx-2"></span>
          <br />
          <span>{`Remote Patient Monitoring`}</span>
          <br />
          <span>{translate('authLayout.rightsReserved')}</span>
        </div>
      </div>
    </>
  )
}

export default reduxForm<{}, RouteComponentProps>({
  form: 'setNewPasswordForm'
})(SetNewPasswordForm)
